export const EUREKA_CLIENT_ID =
  process.env.REACT_APP_EUREKA_CLIENT_ID ?? "visual-deck";

export const EUREKA_AUTHORIZATION_ENDPOINT =
  process.env.REACT_APP_EUREKA_AUTHORIZATION_ENDPOINT ??
  "https://eureka.example.com/oauth2/authorize";

export const EUREKA_TOKEN_ENDPOINT =
  process.env.REACT_APP_EUREKA_TOKEN_ENDPOINT ??
  "https://eureka.example.com/oauth2/token";

export const EUREKA_SCOPES = ["visual-deck"];

export const EUREKA_REDIRECT_PATH =
  process.env.REACT_APP_EUREKA_REDIRECT_PATH ?? "/auth/callback";

export const PKCE_VERIFIER_KEY_PREFIX = "eureka_pkce_verifier_"; // + state
